import { LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import ItemEditor from "./ItemEditor"

/* Protopia Ecosystem component */
export interface IContactsEditorFormProps {
    i:number
    item: any
    children: JSX.Element
    items: any[]
}
const ContactsEditorForm = (props: IContactsEditorFormProps): JSX.Element => {
    const isEdit: boolean = useLandingStore((state: ILandingStore) => state.isEdit )
    return isEdit
        ?
        <>
            {props.children}
            <ItemEditor i={props.i} item={props.item} type={LANDING_TYPE_CONTENT.CONTACTS} items={props.items} />
        </>
        :
        <>{props.children}</>
}
export default ContactsEditorForm